import { Link } from "react-router-dom"
import UniLogo from "assets/AboutUniprest/UniLogo.svg"
import MagicButton from "components/MagicButton/MagicButtonV3"
import { withLocalize } from "components/Lang/Lang"
import FooterMenu from "./FooterMenu"

import AnpcSal from "assets/legal/anpc-sal.png"
import AnpcSol from "assets/legal/anpc-sol.png"

import "./index.scss"

const Footer = (props) => {
  const { className, translate } = props
  
  return (
    <footer data-test-id='PbiZ' className={`footer ${className ?? ""}`}>
      <FooterMenu />
      <div data-test-id='HSMV' className="footer-inner">
        <div data-test-id='iY5x' className="footer-left">
          <div className="company-info">
            <h3 className="company-name">SC Uniprest Instal SRL</h3>
            <div className="company-details">
              <p><span className="label">Reg. com.:</span> J32009000412260</p>
              <p><span className="label">CUI:</span> RO7459637</p>
            </div>
            <div className="contact-info">
              <p><span className="label">Sediu social:</span> str. Băneasa 8, Târgu Mureș, cod postal 540199, jud. Mureș</p>
              <p><span className="label">Tel:</span> <a href="tel:+40365882077">+40 365 882 077</a></p>
              <p><span className="label">E-mail:</span> <a href="mailto:sediu@uniprest.ro">sediu@uniprest.ro</a></p>
            </div>
          </div>
        </div>
        
        <div data-test-id='aqr8' className="footer-center">
          <div className="anpc-logos">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">
              <img src={AnpcSal} alt="ANPC - Soluționarea alternativă a litigiilor" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO" target="_blank" rel="noopener noreferrer">
              <img src={AnpcSol} alt="ANPC - Soluționarea online a litigiilor" />
            </a>
          </div>
        </div>

        <div data-test-id='iyhU' className="footer-right">
          <div className="social-section">
            <div className="social-title">Intră în comunitate:</div>
            <div className="social-icons">
              <MagicButton
                svg="facebook"
                className="socialButton"
                href={"https://www.facebook.com/UniprestInstal"}
                targetBlank
              />
              <MagicButton
                svg="youtube"
                className="socialButton"
                href={"https://www.youtube.com/channel/UCdi1nl8fWeRuQrIzgMgA3XA"}
                targetBlank
              />
              <MagicButton
                svg="linkedin"
                className="socialButton"
                href={"https://www.linkedin.com/company/uniprest-instal-s.r.l./"}
                targetBlank
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default withLocalize(Footer)
